<template>
    <div>
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu v-if="hasSession === 0"/>
            <Navbar v-else-if="hasSession === 1"/>
        </div>

        <div class="section section-color center">
            <div class="w-container" style="padding:40px 0 0 0">
                <h1 class="key-number">{{$t('faq')}}</h1>
            </div>
        </div>

        <div class="page-content">
            <FAQ/>
        </div>

        <Footer/>
    </div>
</template>

<style>
.page-content {
    margin-left: auto;
    margin-right: auto;
    max-width: 800px;
    padding-bottom: 40px;
    padding-left: 1em;
    padding-right: 1em;
}
.header-text p {
    color: #636081;
}
@media (max-width: 991px) {
    .section .w-container .key-number {
        padding: 80px 0 10px 0;
    }
}
@media (max-width: 479px) {
    .page-content {
        margin: 0 20px 0 20px;
        width: 350px;
    }
}
</style>

<script>
import Navbar from "../components/Navbar";
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import session from '../session'

const model = {
    hasSession: -1
};
function hasSessionCallback(result) {
    if (result) {
        model.hasSession = 1;
    } else {
        model.hasSession = 0;
    }
}
session.hasSession(hasSessionCallback);

export default {
    components: {
        Navbar, HeaderMenu, NetworkStatus, FAQ, Footer
    },
    data: function () {
        return model;
    }
}
</script>
